module.exports = __webpack_public_path__ + "img/Zain-Jordan-Ar.f657d732.png";